import type EngineContext from '../state/engine';

export abstract class BaseModule {
    protected _engineContext: EngineContext;

    abstract afterSwitchEngine(): void;

    constructor(engineContext: EngineContext) {
        this._engineContext = engineContext;
    }
}
